import { StepAction } from './stepAction';
import { extractElementId } from '../../utils';
import { featureFlagsService } from '../../commons/featureFlagsService';
import type { SelectOptionStep } from 'clickim/src/common/models/selectOptionStep';

export class SelectOptionStepAction extends StepAction<SelectOptionStep> {
    override async performAction() {
        const target = this.getTarget();
        const { seleniumElement, locatedElement } = target;

        const browserAndOS = await this.driver.getBrowserAndOS();

        const browserMajor = browserAndOS.browserMajor;
        const isSafari = this.driver.isSafari();
        const isShadowed = Boolean(this.step.element?.isShadowed);

        // Force use js code when element is shadow dom in Safari older than 13
        if (!isSafari || (isSafari && browserMajor >= 13 && !isShadowed)) {
            try {
                const res = await this.driver.elementIdClick(extractElementId(seleniumElement));
                return res;
            } catch (err) {
                // If customer overrides the native Element prototype, this click will fail for this reason. in such a case, fallback to use js code.
                if (!err.message.includes('Cannot check the displayedness of a non-Element argument')) {
                    throw err;
                }
            }
        }

        const { selectOption } = await import('./scripts/selectOption');
        const safariSelectOptionDispatchEventOnSelectElement = featureFlagsService.flags.safariSelectOptionDispatchEventOnSelectElement.isEnabled();
        const selectOptionCode = `
            const getLocatedElement = ${this.sessionPlayerInit.codeSnippets.getLocatedElementCode};
            const isNativeFunction = ${this.sessionPlayerInit.utils.isNativeFunction.toString()};
            const selectOption = ${selectOption.toString()};
            return selectOption.apply(null, arguments);
        `;

        const result = await this.driver.executeJS<typeof selectOption>(selectOptionCode, locatedElement, safariSelectOptionDispatchEventOnSelectElement);
        if (result.value?.success) {
            return { success: true };
        }
        return { success: false };
    }
}
